import { render } from "./GenericTable.vue?vue&type=template&id=7dc3478f"
import script from "./GenericTable.vue?vue&type=script&lang=js"
export * from "./GenericTable.vue?vue&type=script&lang=js"

import "./GenericTable.vue?vue&type=style&index=0&id=7dc3478f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__